/**
 * Backend API base URL.
 *
 * Set one of these at build time (Coolify / Docker / .env):
 *   api                  preferred short name (mapped by craco)
 *   API
 *   REACT_APP_API
 *   REACT_APP_BACKEND_URL  legacy
 *
 * Value should be the backend origin only, e.g. https://api.example.com
 * (no trailing slash; `/api` is appended here).
 */
function resolveBackendOrigin() {
  const raw =
    process.env.REACT_APP_API ||
    process.env.REACT_APP_BACKEND_URL ||
    "";
  return String(raw).trim().replace(/\/+$/, "");
}

const origin = resolveBackendOrigin();

/** Base path for all REST calls, e.g. https://api.example.com/api */
export const API = origin ? `${origin}/api` : "/api";

export default API;
